// Textos e rotulos das telas de links (Gerar, Em massa, Historico). Logica pura,
// testada; os codigos vem da edge convert-link e da view link_history.

import type { StoreCode } from "@affiliate/stores";

export interface StoreChip {
  readonly code: StoreCode;
  readonly label: string;
  /** true = link sai direto na loja (ToS proibe encurtador). */
  readonly directOnly: boolean;
}

export const STORE_CHIPS: readonly StoreChip[] = [
  { code: "amazon", label: "Amazon", directOnly: true },
  { code: "mercadolivre", label: "Mercado Livre", directOnly: true },
  { code: "shopee", label: "Shopee", directOnly: false },
  { code: "magalu", label: "Magalu", directOnly: true },
  { code: "aliexpress", label: "AliExpress", directOnly: false },
  { code: "shein", label: "SHEIN", directOnly: true },
  { code: "awin", label: "Lojas Awin", directOnly: false },
  { code: "rakuten", label: "Lojas Rakuten", directOnly: false },
];

const ERROR_MESSAGES: Readonly<Record<string, string>> = {
  credential_missing: "Você ainda não conectou essa loja. Cadastre a credencial em Minha conta.",
  credential_incomplete: "A credencial dessa loja está incompleta. Revise os campos em Minha conta.",
  credential_rejected: "A loja recusou sua credencial. Confira os dados e salve de novo em Minha conta.",
  session_expired: "Sua sessão nessa loja expirou. Reconecte pela extensão e tente de novo.",
  store_not_supported: "Loja não suportada. Para marcas de rede, conecte Awin ou Rakuten.",
  invalid_url: "Esse link não parece válido. Use um endereço completo começando com https://.",
  shein_url_not_canonical: "A SHEIN só aceita o link da página do produto (termina em -p-número.html).",
  advertiser_not_partner: "Essa loja não está entre os seus programas aprovados na rede.",
  provider_unavailable: "A loja está fora do ar ou limitando pedidos. Tente de novo em alguns minutos.",
  provider_error: "A loja não conseguiu gerar o link agora. Tente de novo.",
  duplicate: "Repetido (mesmo produto já está no lote).",
  limit_exceeded: "Acima do limite de 30 links por lote.",
  network_limit: "Acima do limite de 6 links de rede (Awin/Rakuten) por lote.",
};

/** Mensagem pt-BR para um codigo de erro/ignorado da conversao. */
export function conversionMessage(code: string | null | undefined): string {
  if (!code) {
    return ERROR_MESSAGES["provider_error"] as string;
  }
  return ERROR_MESSAGES[code] ?? ERROR_MESSAGES["provider_error"] as string;
}

/** Codigos que pedem acao na tela de credenciais. */
export function needsCredentialAction(code: string | null | undefined): boolean {
  return (
    code === "credential_missing" ||
    code === "credential_incomplete" ||
    code === "credential_rejected" ||
    code === "session_expired"
  );
}

export type ConversionStatus = "converted" | "error" | "ignored" | "pending";

export const STATUS_LABELS: Readonly<Record<ConversionStatus, string>> = {
  converted: "Convertido",
  error: "Erro",
  ignored: "Ignorado",
  pending: "Pendente",
};

export const ORIGIN_LABELS: Readonly<Record<string, string>> = {
  panel: "Painel",
  bot: "Bot",
  forwarding: "Encaminhamento",
  extension: "Extensão",
};

export const LINK_TYPE_LABELS: Readonly<Record<string, string>> = {
  short: "Curto",
  direct: "Direto",
};

export function originLabel(origin: string | null | undefined): string {
  return origin ? ORIGIN_LABELS[origin] ?? origin : "-";
}

export function linkTypeLabel(type: string | null | undefined): string {
  return type ? LINK_TYPE_LABELS[type] ?? type : "-";
}
